import { MonthValue } from '@enums/Date';

export class ApiUtils {
  static async handleApiResponse<T>(
    apiCall: Promise<{ parsedBody?: T }>,
    onSuccess: (data: T) => void,
    errorMessage: string,
  ): Promise<void> {
    try {
      const response = await apiCall;
      if (!response?.parsedBody) {
        throw new Error('No data received');
      }
      onSuccess(response.parsedBody);
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(`${errorMessage} ${error.message}`);
      } else {
        console.error(errorMessage, error);
      }
    }
  }
  static async handleApiResponse1<T>(
    apiCall: Promise<{ parsedBody?: T; status?: number }>,
    onSuccess: (data: T | undefined, statusCode: number) => void,
    errorMessage: string,
  ): Promise<void> {
    try {
      const response = await apiCall;
      const statusCode = response.status ?? 200;
      onSuccess(response.parsedBody, statusCode); // Always call onSuccess
    } catch (error: any) {
      const status = error?.status ?? 0;
      const message =
        error?.message ||
        ApiUtils.getMessageFromStatusCode(status, errorMessage);
      throw { status, message };
    }
  }

  static getMessageFromStatusCode(status: number, context?: string): string {
    let baseMessage = '';

    switch (status) {
      case 204:
        baseMessage = 'No data available.';
        break;
      case 400:
        baseMessage = 'Bad Request. Please check your input.';
        break;
      case 401:
        baseMessage = 'Unauthorized. Please login again.';
        break;
      case 403:
        baseMessage = 'Forbidden. You do not have access.';
        break;
      case 404:
        baseMessage = 'Requested data not found.';
        break;
      case 500:
        baseMessage = 'Internal server error. Please try again later.';
        break;
      case 0:
        baseMessage = 'Network error. Please check your connection.';
        break;
      default:
        baseMessage = `Unexpected error (Status code: ${status}).`;
        break;
    }

    return context ? `${context}: ${baseMessage}` : baseMessage;
  }
}

export function processMonthYear(monthYear: string | undefined) {
  if (monthYear) {
    const [month, year] = monthYear.split(' ');
    const numericMonth = MonthValue[month as keyof typeof MonthValue];
    return {
      month: numericMonth, // "10"
      year: year, // "2024"
    };
  } else {
    return null;
  }
}
